import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { GridsterModule } from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';
import { PhoenixDirectivesModule } from '../../../directives/directives.module';
import { CardWidgetComponent } from './card-widget/card-widget.component';
import { SubjectCardWidgetComponent } from './subject-card-widget.component';
import { ReferralWidgetComponent } from './referral-widget/referral-widget.component';
import { FacReportWidgetComponent } from './referral-widget/fac-report-widget/fac-report-widget.component';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { ReferralDataWidgetComponent } from './referral-widget/referral-data-widget/referral-data-widget.component';
import { TranslationControlsComponentModule } from 'app/components/translation-controls/translation-controls.module';
import { LabelWidgetsModule } from '../label-widgets/label-widgets.module';

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDividerModule,
        MatMenuModule,
        GridsterModule,
        FuseWidgetModule,
        FuseSharedModule,
        PhoenixDirectivesModule,
        PhoenixPipesModule,
        DynamicModule,
        TranslationControlsComponentModule,
        LabelWidgetsModule,
    ],
    declarations: [
        CardWidgetComponent,
        ReferralWidgetComponent,
        FacReportWidgetComponent,
        ReferralDataWidgetComponent,
        SubjectCardWidgetComponent,
    ],
    providers: [],
    exports: [
        CardWidgetComponent,
        ReferralWidgetComponent,
        FacReportWidgetComponent,
        ReferralDataWidgetComponent,
        SubjectCardWidgetComponent,
    ]
})
export class CardWidgetsModule { }
